<div class="container">
  <div class="section-header">
    <p class="eyebrow">Why Build with Tricore?</p>
    <h2>Beyond capital: we are your technical co-founders.</h2>
  </div>

  <div class="review-grid">
    <article class="review-card" *ngFor="let reason of reasons">
      <div class="review-body">
        <span class="review-accent" aria-hidden="true"></span>
        <h3 class="reason-title">{{ reason.title }}</h3>
        <p class="reason-copy">{{ reason.description }}</p>
      </div>
    </article>
  </div>
</div>
